import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ForumService } from './forum.service';

@Component({
  selector: 'app-forum',
  templateUrl: './forum.component.html',
  styleUrls: ['./forum.component.scss']
})
export class ForumComponent implements OnInit {

  forumForm: any
  currentConfiguration: any
  currentImage: any = {
    id: '',
    type: "vehicle_main_photo"
  }
  images: any = []
  firstConfiguration: boolean = false
  changedImage: boolean = false
  configurationId: string

  constructor( private formBuilder: FormBuilder, private forumService: ForumService ) {

  }



  onUploadMedia(event) {

    console.log(event)
    this.imageHandler(event)

    this.saveForumData()

  }



  constructForumForm() {

    this.forumForm = this.formBuilder.group({

      phrase: this.formBuilder.control(''),
      picture: this.formBuilder.control(''),
      categoryName: this.formBuilder.control(''),
      categories: this.formBuilder.array([]),
      subcategoryName: this.formBuilder.control(''),
      subcategories: this.formBuilder.array([])

    })

  }



  getForumConfiguration() {

    this.forumService.getConfigurations().subscribe(

      response => {

        let data = response.json().configurations[0]

        if(data === undefined) {

          this.firstConfiguration = true

        } else {

          this.currentConfiguration = data
          this.configurationId = data._id

          this.images = [ data.collaboratorPhoto ]

          this.forumForm.patchValue({

            phrase: data.phrase

          })

        }

      }

    )


  }



  getCategories() {

    this.forumService.getCategories().subscribe(

      response => {

        let categoriesGeted = response.json().categories

        for(let category of categoriesGeted) {

          const data = this.formBuilder.group({

            label: category.label,
            value: category.value

          })

          this.categories.push(data)

        }

      }

    )


  }



  getSubcategories() {

    this.forumService.getSubcategories().subscribe(

      response => {

        let subcategoriesGeted = response.json().subCategories

        for(let subcategory of subcategoriesGeted) {

          const data = this.formBuilder.group({

            label: subcategory.label,
            value: subcategory.value

          })

          this.subcategories.push(data)

        }

      }

    )


  }



  getForumInfos() {

    this.getForumConfiguration()
    this.getCategories()
    this.getSubcategories()

  }



  ngOnInit() {

    this.constructForumForm()
    this.getForumInfos()

  }



  imageHandler(images) {

    this.forumForm._value.picture = images[0]
    console.log(images)
    this.changedImage = true

  }



  get categories() {

    return this.forumForm.controls['categories'] as FormArray

  }



  get subcategories() {

    return this.forumForm.controls['subcategories'] as FormArray

  }



  addFormArray(target, controlName) {

    const data = this.formBuilder.group({

      label: this.formBuilder.control(this.forumForm._value[controlName])

    })

    this[target].push(data)

    if(controlName === 'categoryName') {

      this.forumForm.patchValue({

        categoryName: ''

      })

    } else {

      this.forumForm.patchValue({

        subcategoryName: ''

      })

    }

  }



  saveConfiguration(configurations) {

    if(this.firstConfiguration) {

      this.forumService.saveConfigurations(configurations).subscribe(response => this.firstConfiguration = false)

    } else {

      this.forumService.updateConfigurations(configurations).subscribe()

    }

  }



  removeFormArray(target, index) {

    if(target === 'categories') {

      this.forumService.deleteCategories(this.forumForm._value.categories[index].value).subscribe()

    } else {

      this.forumService.deleteSubcategories(this.forumForm._value.subcategories[index].value).subscribe()

    }

    this[target].removeAt(index)

  }



  saveForumData() {

    for(let category of this.forumForm._value.categories) {

      if(!category.hasOwnProperty('value')) {

        let categoryFormated = {

          name: category.label,
          active: true

        }

        this.forumService.saveCategories(categoryFormated).subscribe(

          response => {

            this.forumForm.controls.categories.controls = []
            this.getCategories()

          }

        )

      }

    }



    for(let subcategory of this.forumForm._value.subcategories) {

      if(!subcategory.hasOwnProperty('value')) {

        let subcategoryFormated = {

          name: subcategory.label,
          active: true

        }

        this.forumService.saveSubcategories(subcategoryFormated).subscribe(

          response => {

            this.forumForm.controls.subcategories.controls = []
            this.getSubcategories()

          }

        )

      }

    }



    if(this.changedImage) {

      let formData = new FormData()

      formData.append('image', this.forumForm._value.picture)

      this.forumService.uploadProfilePicture(formData).subscribe(

        response => {

          let photoData = response.json()

          let configurationsFormated = {

            id: this.configurationId,
            phrase: this.forumForm._value.phrase,
            collaboratorPhoto: {
              contentType: photoData.contentType,
              fileName: photoData.fileName
            }

          }

          this.images = [ configurationsFormated.collaboratorPhoto ]
          this.changedImage = false

          this.saveConfiguration(configurationsFormated)

        }

      )

    } else {

      let configurationsFormated = {

        id: this.configurationId,
        phrase: this.forumForm._value.phrase,
        collaboratorPhoto: {
          contentType: this.currentConfiguration.collaboratorPhoto.contentType,
          fileName: this.currentConfiguration.collaboratorPhoto.fileName
        }

      }

      this.saveConfiguration(configurationsFormated)

    }

  }

}



// WEBPACK FOOTER //
// ./src/app/forum/forum.component.ts